import { useAtomValue } from "jotai";
import { useTranslation } from "react-i18next";
import { FCC } from "types";

import { ButtonLink } from "@/components/Interface/Button/Button";
import { DefaultPageLayout } from "@/components/Layout/BaseLayouts/DefaultPageLayout";
import { PageSection } from "@/components/Layout/BaseLayouts/PageSection";
import { portalRoutes } from "@/router/routes/portalRoutes";
import { accessTokenAtom, isAnonymousUserAtom } from "@/utils/atoms";

export const NotFound: FCC = () => {
  const { t } = useTranslation();
  const accessToken = useAtomValue(accessTokenAtom);
  const isAnonymousUser = useAtomValue(isAnonymousUserAtom);
  const backTo =
    accessToken && !isAnonymousUser ? portalRoutes.cockpit.base : "/welcome";

  return (
    <DefaultPageLayout headline={t("Error.404.title")}>
      <div
        className="col-span-full flex flex-col items-center"
        data-testid="not-found-content"
      >
        <PageSection
          className="flex flex-col items-center gap-6 text-center"
          spacing="vertical"
        >
          <h1 className="sr-only">{t("Error.404.title")}</h1>
          <p className="max-w-[600px] text-body-base leading-md text-foreground-primary">
            {t("Error.404.text")}
          </p>
          <ButtonLink
            to={backTo}
            variant="primary"
            data-testid="not-found-back-link"
          >
            {t("Error.404.backToThePortal")}
          </ButtonLink>
        </PageSection>
      </div>
    </DefaultPageLayout>
  );
};
